module.exports = __webpack_public_path__ + "a0f2a150d2392f6422af54f30bcd6f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_130.jpg
// module id = 1662
// module chunks = 5